import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { getPaymentTerminalPayUrl } from '../../services/paymentService';

const CirclePieces = ({ posId, value, size = 9.5 }) => {
    const qrValue = value || getPaymentTerminalPayUrl(posId);
    if (!qrValue) return null;

    const qrSize = Math.round(size * 30);

    return (
        <div className="flex items-center justify-center p-4">
            <div className="rounded-2xl border-2 border-amber-500 bg-white p-4 shadow-lg">
                <QRCodeSVG
                    value={qrValue}
                    size={qrSize}
                    level="H"
                    includeMargin
                    fgColor="#1e293b"
                    bgColor="#FFFFFF"
                />
            </div>
        </div>
    );
};

export default CirclePieces;
